export default __webpack_public_path__ + "static/media/connect.c242160f.mp4";